module.exports = __webpack_public_path__ + "static/media/quindio-32.55899220.jpg";